export default __webpack_public_path__ + "static/media/crm_documents.4ac6dc40.svg";